import { render, staticRenderFns } from "./TarafListPicker.vue?vue&type=template&id=4df6c95e"
import script from "./TarafListPicker.vue?vue&type=script&lang=ts"
export * from "./TarafListPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports